@if (settings) {
  <ul class="field-list">
    <li>
      <label><nb-icon icon="clock-outline"></nb-icon><span>{{ 'quotes.settings.validity_days' | translate }}</span><span class="required">*</span></label>
      <span class="with-unit">
        <input nbInput type="number" min="1" max="365" [attr.aria-label]="'quotes.settings.validity_days' | translate" fieldSize="small" [status]="errors.validity_days ? 'danger' : 'basic'" [(ngModel)]="settings.validity_days">
        <span class="unit">{{ 'quotes.settings.days' | translate }}</span>
      </span>
      @if (error('validity_days'); as message) { <span class="error">{{ message }}</span> }
    </li>
  </ul>
  <h3>{{ 'quotes.settings.texts' | translate }}</h3>
  <nb-button-group size="small" class="locales" [attr.aria-label]="'quotes.settings.language' | translate">
    @for (l of locales; track l) {
      <button nbButtonToggle type="button" [pressed]="l === locale" (pressedChange)="$event && (locale = l)">{{ 'quotes.settings.locale.' + l | translate }}</button>
    }
  </nb-button-group>
  <ul class="texts">
    @for (slot of slots; track slot) {
      <li>
        <label [for]="'quote-text-' + slot">{{ 'quotes.text.' + slot | translate }}</label>
        <textarea nbInput fullWidth rows="4" maxlength="20000" [id]="'quote-text-' + slot" [(ngModel)]="settings.texts[locale][slot]"></textarea>
      </li>
    }
  </ul>
  <div class="actions">
    <button nbButton size="small" status="primary" [disabled]="busy" (click)="save()"><nb-icon icon="checkmark"></nb-icon><span>{{ 'save' | translate }}</span></button>
  </div>
}
